import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ManualReplacePageRoutingModule } from './manual-replace-routing.module';

import { ManualReplacePage } from './manual-replace.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ManualReplacePageRoutingModule
  ],
  declarations: [ManualReplacePage],
  exports: [
    ManualReplacePage
  ],
})
export class ManualReplacePageModule {}
